// Articles de blog Catherine' Shiatsu — contenu SEO-optimisé
// Chaque article a un slug unique, meta title/description, mots-clés et contenu structuré

export const articles = [
  {
    slug: "shiatsu-stress-anxiete-retrouver-serenite",
    title: "Shiatsu et stress : retrouver sérénité et équilibre émotionnel",
    excerpt:
      "Le stress chronique impacte notre santé physique et mentale. Découvrez comment le Shiatsu agit en profondeur pour libérer les tensions et restaurer la sérénité.",
    date: "2025-04-02",
    category: "Bien-être",
    readTime: 5,
    cover:
      "https://images.unsplash.com/photo-1611934180042-da791b4091e7?w=1400&q=80",
    meta: {
      title: "Shiatsu contre le stress et l'anxiété | Catherine' Shiatsu La Ciotat",
      description:
        "Comment le Shiatsu aide à gérer le stress, l'anxiété et les émotions. Une approche manuelle douce et efficace pour retrouver sérénité et équilibre émotionnel.",
      keywords:
        "shiatsu stress, shiatsu anxiété, gestion du stress, bien-être émotionnel, La Ciotat",
    },
    content: [
      {
        type: "p",
        text: "Le stress est devenu le mal du siècle. Entre la vie professionnelle, les responsabilités familiales et la pression permanente, notre système nerveux est sollicité en continu. À long terme, ce stress chronique fragilise notre équilibre physique, émotionnel et immunitaire. Le Shiatsu offre une réponse concrète, douce et profondément apaisante.",
      },
      { type: "h2", text: "Comment le stress s'installe-t-il dans le corps ?" },
      {
        type: "p",
        text: "Le stress active notre système nerveux sympathique : respiration rapide, tension musculaire, libération de cortisol… Lorsque cet état se prolonge, des zones du corps se crispent durablement (épaules, nuque, plexus solaire), le sommeil se détériore, et l'esprit peine à se poser. Le Shiatsu agit précisément sur ces mécanismes.",
      },
      { type: "h2", text: "L'action du Shiatsu sur le système nerveux" },
      {
        type: "p",
        text: "Par des pressions toniques et rythmées sur les méridiens, le Shiatsu stimule le système nerveux parasympathique — celui qui induit la détente. La respiration se ralentit, le rythme cardiaque s'apaise, les muscles se relâchent. Le mental suit naturellement : les pensées tournent moins en boucle, la clarté revient.",
      },
      { type: "h2", text: "Quelques séances suffisent pour ressentir la différence" },
      {
        type: "p",
        text: "Dès la première séance, la plupart des personnes ressentent un grand calme. À partir de trois à cinq séances rapprochées, un travail de fond peut s'installer : meilleure gestion des émotions, sommeil plus réparateur, baisse de l'irritabilité, et surtout un sentiment de reconnexion avec soi-même.",
      },
      { type: "h2", text: "En complément d'autres approches" },
      {
        type: "p",
        text: "Le Shiatsu se marie parfaitement avec la méditation, la cohérence cardiaque, le yoga ou toute autre démarche de bien-être. Il ne remplace pas un suivi médical ou psychologique en cas de troubles sévères, mais il constitue un soutien précieux pour traverser les périodes difficiles.",
      },
    ],
  },
  {
    slug: "shiatsu-entreprise-qvct-bien-etre-salaries",
    title: "Le Shiatsu en entreprise : un atout pour la QVCT",
    excerpt:
      "TMS, stress, fatigue : comment le Shiatsu sur chaise s'intègre dans une démarche QVCT pour prévenir les risques et renforcer le bien-être des collaborateurs.",
    date: "2025-04-18",
    category: "Entreprises",
    readTime: 5,
    cover:
      "https://customer-assets.emergentagent.com/job_layout-109/artifacts/kl2dzzv4_21194.jpg",
    meta: {
      title: "Shiatsu en entreprise et QVCT | Prestations Catherine' Shiatsu",
      description:
        "Prestations de Shiatsu en entreprise pour la Qualité de Vie et Conditions de Travail. Séances courtes de 20 à 30 min, idéales pour prévenir les TMS et les RPS.",
      keywords:
        "shiatsu entreprise, QVCT, TMS, RPS, bien-être au travail, prévention, Provence",
    },
    content: [
      {
        type: "p",
        text: "La Qualité de Vie et des Conditions de Travail (QVCT) est aujourd'hui au cœur des préoccupations des entreprises et des collectivités. Prévenir les troubles musculo-squelettiques, réduire les risques psychosociaux, favoriser l'engagement des équipes : autant d'enjeux auxquels le Shiatsu apporte une réponse concrète et accessible.",
      },
      { type: "h2", text: "Pourquoi intégrer le Shiatsu dans sa politique QVCT ?" },
      {
        type: "p",
        text: "Les TMS représentent la première maladie professionnelle reconnue en France. Le stress, quant à lui, est à l'origine d'un absentéisme croissant. Le Shiatsu, reconnu comme un outil efficace de prévention, agit sur les deux plans : il soulage les tensions physiques accumulées (nuque, épaules, dos) et apaise la charge mentale.",
      },
      { type: "h2", text: "Comment se déroule une intervention en entreprise ?" },
      {
        type: "p",
        text: "Les séances se déroulent sur le temps de travail, sur une chaise ergonomique spécialement conçue pour le Shiatsu assis. Chaque soin dure entre 20 et 30 minutes, avec un intervalle de 10 minutes entre deux passages. Le collaborateur reste habillé et peut reprendre immédiatement son activité, avec un regain d'énergie et de concentration.",
      },
      { type: "h2", text: "Formules proposées" },
      {
        type: "p",
        text: "J'interviens à la demi-journée (5 à 6 soins pour 200 €) ou à la journée complète (10 à 12 soins pour 300 €) dans les entreprises de La Ciotat, Aubagne, Aix-en-Provence et Marseille. J'apporte mon matériel et m'adapte à votre espace.",
      },
      { type: "h2", text: "Un investissement rentable pour l'entreprise" },
      {
        type: "p",
        text: "Au-delà du bien-être immédiat, le Shiatsu en entreprise renforce le sentiment de reconnaissance des salariés, fidélise les talents et améliore la performance collective. C'est un geste fort envers les équipes, dont les retombées se mesurent à moyen terme sur la cohésion et l'engagement.",
      },
    ],
  },
  {
    slug: "shiatsu-sommeil-retrouver-nuits-reparatrices",
    title: "Shiatsu et sommeil : retrouver des nuits réparatrices",
    excerpt:
      "Difficultés d'endormissement, réveils nocturnes, sommeil non réparateur : le Shiatsu agit en profondeur sur les mécanismes du sommeil. Explications et conseils.",
    date: "2025-05-10",
    category: "Bien-être",
    readTime: 5,
    cover:
      "https://images.unsplash.com/photo-1621554258209-a4a4305e29e5?w=1400&q=80",
    meta: {
      title: "Shiatsu et sommeil : retrouver des nuits réparatrices",
      description:
        "Insomnies, réveils nocturnes, sommeil agité… Découvrez comment le Shiatsu peut rétablir un sommeil de qualité en agissant sur les déséquilibres énergétiques.",
      keywords:
        "shiatsu sommeil, insomnie, réveils nocturnes, fatigue, médecine chinoise, La Ciotat",
    },
    content: [
      {
        type: "p",
        text: "Un tiers des Français déclare mal dormir. Entre les difficultés d'endormissement, les réveils au milieu de la nuit et le sentiment de ne pas avoir récupéré au réveil, les troubles du sommeil pèsent lourdement sur la santé physique, la concentration et l'équilibre émotionnel. Le Shiatsu, par son action globale, offre une voie intéressante pour retrouver des nuits sereines.",
      },
      { type: "h2", text: "Sommeil et équilibre énergétique" },
      {
        type: "p",
        text: "Dans la médecine traditionnelle chinoise, chaque organe est associé à un horaire précis. Les réveils répétés autour de 3 h du matin, par exemple, sont souvent mis en lien avec le foie. Le Shiatsu permet d'identifier ces déséquilibres et de les traiter en profondeur.",
      },
      { type: "h2", text: "Relâcher le mental pour laisser place au sommeil" },
      {
        type: "p",
        text: "Souvent, l'insomnie n'est pas un problème de corps fatigué, mais d'esprit agité. En relâchant les tensions physiques, le Shiatsu aide le mental à lâcher prise. La respiration s'approfondit, le système nerveux bascule en mode parasympathique, et le sommeil peut enfin survenir naturellement.",
      },
      { type: "h2", text: "Quelques conseils complémentaires" },
      {
        type: "p",
        text: "Pour optimiser l'effet du Shiatsu sur le sommeil, il est utile de soigner son hygiène de vie : éviter les écrans au moins une heure avant le coucher, privilégier un dîner léger, instaurer un rituel apaisant (tisane, lecture, respiration consciente). Le Shiatsu amplifie et pérennise les effets de ces bonnes habitudes.",
      },
    ],
  },
  {
    slug: "preparer-seance-shiatsu-tout-savoir",
    title: "Se préparer à une séance de Shiatsu : tout ce qu'il faut savoir",
    excerpt:
      "Quelle tenue choisir ? Comment manger avant ? Que faire après ? Un guide pratique pour profiter pleinement de votre séance de Shiatsu.",
    date: "2025-05-28",
    category: "Conseils pratiques",
    readTime: 4,
    cover:
      "https://customer-assets.emergentagent.com/job_layout-109/artifacts/3c6j0mzw_IMG-20240916-WA0008.jpg",
    meta: {
      title: "Préparer sa séance de Shiatsu : guide pratique",
      description:
        "Conseils pratiques pour bien préparer votre séance de Shiatsu : tenue, alimentation, attitude à adopter avant et après le soin pour en tirer tous les bénéfices.",
      keywords:
        "préparer séance shiatsu, conseils shiatsu, première séance, tenue, alimentation",
    },
    content: [
      {
        type: "p",
        text: "Vous avez pris rendez-vous pour votre première séance de Shiatsu et vous vous demandez comment bien vous y préparer ? Voici un guide pratique pour aborder votre soin dans les meilleures conditions et en tirer pleinement profit.",
      },
      { type: "h2", text: "La tenue idéale" },
      {
        type: "p",
        text: "Le Shiatsu se pratique habillé. Privilégiez des vêtements souples, confortables et en matière naturelle (coton, lin). Un legging ou un pantalon léger, un t-shirt à manches longues, et des chaussettes fines suffisent. Évitez les jeans et les tissus épais qui limiteraient les pressions et les étirements.",
      },
      { type: "h2", text: "Avant la séance" },
      {
        type: "p",
        text: "Évitez les repas lourds dans les deux heures précédant le soin : le système digestif très sollicité gêne le travail énergétique. Une collation légère est en revanche recommandée si vous avez faim. Pensez à bien vous hydrater et, si possible, accordez-vous quelques minutes de calme avant d'arriver pour vous déposer.",
      },
      { type: "h2", text: "Pendant la séance" },
      {
        type: "p",
        text: "Un court échange initial permet de faire le point sur vos antécédents, votre état du jour et vos attentes. Pendant le soin, laissez-vous aller : respirez naturellement, fermez les yeux si vous le souhaitez. Si une pression est inconfortable, n'hésitez pas à le signaler — l'intensité est toujours ajustable.",
      },
      { type: "h2", text: "Après la séance" },
      {
        type: "p",
        text: "Prévoyez si possible un moment calme après le soin. Buvez de l'eau pour accompagner l'élimination des toxines. Il est normal de ressentir une grande détente, parfois une fatigue passagère, voire des émotions qui remontent. Ces réactions sont le signe que le travail énergétique opère. Les effets bénéfiques se déploient sur plusieurs jours.",
      },
    ],
  },
  {
    slug: "shiatsu-douleurs-chroniques-approche-complementaire",
    title: "Shiatsu et douleurs chroniques : une approche complémentaire",
    excerpt:
      "Lombalgies, cervicalgies, migraines… Le Shiatsu n'est pas un traitement médical, mais il offre un accompagnement précieux dans la gestion des douleurs chroniques.",
    date: "2025-06-12",
    category: "Soins et pathologies",
    readTime: 5,
    cover:
      "https://customer-assets.emergentagent.com/job_layout-109/artifacts/o6qijess_21207.jpg",
    meta: {
      title: "Shiatsu et douleurs chroniques | Approche complémentaire",
      description:
        "Comment le Shiatsu accompagne les personnes souffrant de douleurs chroniques (dos, cervicales, migraines) en complément d'un suivi médical approprié.",
      keywords:
        "shiatsu douleur, lombalgie, cervicalgie, migraine, douleur chronique, accompagnement",
    },
    content: [
      {
        type: "p",
        text: "Les douleurs chroniques touchent des millions de personnes en France. Lombalgies, cervicalgies, migraines, douleurs articulaires : ces troubles altèrent profondément la qualité de vie. Si le Shiatsu ne se substitue en aucun cas à un suivi médical, il constitue un accompagnement pertinent et reconnu, agissant en profondeur sur les causes énergétiques et les tensions qui entretiennent la douleur.",
      },
      { type: "h2", text: "Comprendre la douleur chronique" },
      {
        type: "p",
        text: "Contrairement à la douleur aiguë — un signal d'alarme utile — la douleur chronique s'installe dans la durée, souvent sans cause mécanique claire. Elle crée un cercle vicieux : la douleur génère des tensions, qui entretiennent la douleur, qui affecte le moral, qui amplifie la perception douloureuse…",
      },
      { type: "h2", text: "Comment le Shiatsu agit-il ?" },
      {
        type: "p",
        text: "Le Shiatsu travaille sur trois plans complémentaires. D'abord, les tensions musculaires locales : par ses pressions, il libère les contractures qui entourent la zone douloureuse. Ensuite, la circulation énergétique : en rétablissant le flux du Ki sur les méridiens concernés, il lève des blocages souvent à l'origine de la douleur. Enfin, le système nerveux : en induisant un état de détente profonde, il diminue la perception de la douleur.",
      },
      { type: "h2", text: "Un accompagnement au long cours" },
      {
        type: "p",
        text: "Pour les douleurs installées depuis longtemps, un travail régulier est recommandé : une séance toutes les trois à quatre semaines, pendant plusieurs mois, permet souvent d'observer une amélioration progressive et durable. Le Shiatsu agit en synergie avec la kinésithérapie, l'ostéopathie ou les traitements médicaux prescrits.",
      },
      { type: "h2", text: "Important : toujours consulter un professionnel de santé" },
      {
        type: "p",
        text: "En cas de douleurs persistantes ou de troubles sévères, consultez impérativement un médecin. Le Shiatsu est un complément, jamais un substitut. N'hésitez pas à parler de votre démarche à votre professionnel de santé, qui pourra vous conseiller au mieux.",
      },
    ],
  },
];

export const getArticleBySlug = (slug) =>
  articles.find((a) => a.slug === slug);

export const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
